var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FB8C00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1619 9.99079C18.5269 7.99371 21.4729 7.99371 22.8378 9.9908L23.3777 10.7807C26.7603 15.7297 29.6665 20.988 32.0574 26.4851L32.1702 26.7444C33.0127 28.6816 31.7398 30.8812 29.6403 31.1159C23.2333 31.832 16.7664 31.832 10.3594 31.1159C8.25996 30.8812 6.987 28.6816 7.82957 26.7444L7.94234 26.4851C10.3333 20.988 13.2395 15.7297 16.622 10.7807L17.1619 9.99079ZM21.2499 16.25C21.2499 16.9404 20.6902 17.5 19.9999 17.5C19.3095 17.5 18.7499 16.9404 18.7499 16.25C18.7499 15.5596 19.3095 15 19.9999 15C20.6902 15 21.2499 15.5596 21.2499 16.25ZM19.9999 19.6875C20.5177 19.6875 20.9374 20.1072 20.9374 20.625V26.875C20.9374 27.3928 20.5177 27.8125 19.9999 27.8125C19.4821 27.8125 19.0624 27.3928 19.0624 26.875V20.625C19.0624 20.1072 19.4821 19.6875 19.9999 19.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastWarning);
export default __webpack_public_path__ + "static/media/toast_warning.b0164a89f56e49e0067eec5add942abc.svg";
export { ForwardRef as ReactComponent };